import API from "../API";

export const GetWishlistApi = async () => {
  try {
    const response = await API.get(`/ecommerce/wishlist`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddToWishlistApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/wishlist`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSingleWishlistItemApi = async (wishlistItemId) => {
  try {
    const response = await API.get(`/ecommerce/wishlist/${wishlistItemId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteWishlistItemApi = async (wishlistItemId) => {
  try {
    const response = await API.delete(`/ecommerce/wishlist/${wishlistItemId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ClearWishlistApi = async () => {
  try {
    const response = await API.delete(`/ecommerce/clear/wishlist`);
    return response;
  } catch (error) {
    throw error;
  }
};
